import styled from 'styled-components';

export default styled.div`
  margin-top: 16px;
  background: #fff;
  padding: 34px 0;
  text-align: center;
  border-radius: 6px;

  svg {
    animation-name: spin;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    width: 24px;
    height: 24px;
  }

  @keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
  }
`;

